// extracted by mini-css-extract-plugin
module.exports = {"Main":"App_Main__2HFIC","Footer":"App_Footer__jEZrh"};